export default "__VITE_ASSET__CYuSBTjC__"